<template>
    <div class="vueperslides__track-inner">
        <div class="vueperslide">
            <div class="vueperslide__content-wrapper">
                <div class="card-prize">
                    <div class="vueperslide__title">
                        <h5>{{prizesContent.year}}</h5>
                    </div>
                    <div class="vueperslide__content">
                        <h3 v-html="sanitizeHtml(prizesContent.title)"></h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sanitizeHtml } from '@/helpers/sanitize.js';

export default {
    props: {
        prizesContent: {
            type: Object
        }
    },
    methods: {
        sanitizeHtml
    }
}
</script>

<style scoped>
.card-prize{
    width: auto;
    height: 80%;
}
.vueperslide__title{
    text-align: left;
    color: var(--primary-color);
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 8px;
}
.vueperslide__content{
    color: var(--secondary-color);
    text-align: left;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 12px;
    max-width: 270px;
}
.vueperslide__content h3{
    padding: 0 10px;
}
.vueperslide__content span {
    display: block;
    font-size: 14px;
    line-height: 24px;
}
</style>